<div mat-dialog-content>
    <mat-dialog-content class="modal-body overflow-auto">
            <b>There was an error saving your card.</b>
    </mat-dialog-content>
</div>
